import useSWR from 'swr';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import Loading from '@/components/Loading/Loading';
import Slider from '@/components/slider/Slider';
import ProductCard from '../category/ProductCard';
import { defaultBreakpoints } from '@/lib/common/breakpoints';
import Section from '../commons/Section';
import { objectToUrlParams } from '../collections-v2/common/YouMayAlsoLike/helpers';

interface MoreFromBrandProps {
  sectionClasses?: string;
  brand: string;
  category: string;
}

const ProductCarousel = ({ brand }: { brand: string }) => {
  const qs = objectToUrlParams({
    brand,
  });

  const { data } = useSWR<SearchOffers[] | null>(
    () => `/api/collections/brand-search-offers?${qs}`,
  );

  if (data == null) return <Loading />;

  if (data.length < 10) return null; // Do not display the Carousel if we have less than 10 offers

  const sectionTitle = `More From ${brand}`;

  return (
    <Section>
      <h2 className="flex items-center text-lg font-semibold md:text-xl">
        {sectionTitle}
      </h2>
      <div className="relative mt-6">
        <Slider breakpoints={defaultBreakpoints} speed={300}>
          {data.map((offer) => (
            <ProductCard offer={offer} />
          ))}
        </Slider>
      </div>
    </Section>
  );
};

export default function MoreFromBrand(props: MoreFromBrandProps) {
  const { brand, category } = props;
  const shouldHideCarousel = [
    'Smartphones',
    'Smartwatches',
    'Laptops',
    'Tablets',
  ].includes(category);

  if (!brand || shouldHideCarousel) return null;

  return <ProductCarousel brand={brand} />;
}
